import { ArrowDownIcon } from "@phosphor-icons/react/dist/csr/ArrowDown";
import { ArrowUpIcon } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { MinusIcon } from "@phosphor-icons/react/dist/csr/Minus";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

export type StatDirection = "up" | "down" | "flat";

export interface StatDeltaProps {
  direction: StatDirection;
  label: string;
  className?: string;
}

const ICONS = {
  up: <ArrowUpIcon size={10} />,
  down: <ArrowDownIcon size={10} />,
  flat: <MinusIcon size={10} />,
} as const;

export const StatDelta = ({ direction, label, className }: StatDeltaProps) => {
  const toneClass = {
    "text-success": direction === "up",
    "text-danger": direction === "down",
    "text-subtle": direction === "flat",
  };
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      <span
        aria-hidden="true"
        className={cn(
          "inline-flex size-3.5 items-center justify-center rounded-full",
          {
            "bg-success-bold text-on-success": direction === "up",
            "bg-danger-bold text-on-danger": direction === "down",
            "text-subtle": direction === "flat",
          },
        )}
      >
        {ICONS[direction]}
      </span>
      <Text weight="semibold" variant="caption" className={cn(toneClass)}>
        {label}
      </Text>
    </span>
  );
};
